import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottomDrawerComponent } from './bottom-drawer/bottom-drawer.component';
import { IonicModule } from '@ionic/angular';
import { MachineInfoComponent } from './bottom-drawer/machine-info/machine-info.component';
import { FieldInfoComponent } from './bottom-drawer/field-info/field-info.component';
import { LocationInfoComponent } from './bottom-drawer/location-info/location-info.component';
import { NotificationsComponent } from './bottom-drawer/notifications/notifications.component';
// TODO Move all from shared Module to this module, no need for twice shared modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { EmployerSelectComponent } from './employer-select/employer-select.component';
import { EmployerSelectDialogComponent } from './employer-select-dialog/employer-select-dialog.component';
import { EmployerAddDialogComponent } from './employer-add-dialog/employer-add-dialog.component';
import { RequestTestAccountDialogComponent } from './request-test-account-dialog/request-test-account-dialog.component';
import { MapExaComponent } from './map/map-exa.component';
import { TranslateModule } from '@ngx-translate/core';
import { MachineModalComponent } from './machine-modal/machine-modal.component';
import { FuelAddDialogComponent } from './fuel-add-dialog/fuel-add-dialog.component';
import { CommentAddDialogComponent } from './comment-add-dialog/comment-add-dialog.component';
import { ImplementSelectDialogComponent } from './implement-select-dialog/implement-select-dialog.component';
import { CustomerSelectDialogComponent } from './customer-select-dialog/customer-select-dialog.component';
import { BrandSelectDialogComponent } from './brand-select-dialog/brand-select-dialog.component';
import { SettingsDialogComponent } from './settings-dialog/settings-dialog.component';
import { AssignMachineDialogComponent } from './assign-machine-dialog/assign-machine-dialog.component';
import { DaySelectorComponent } from './day-selector/day-selector.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MachineListComponent } from './machine-list/machine-list.component';
import { ExaNewMapComponent } from './exa-new-map/exa-new-map.component';
import { MapComponent } from './exa-new-map/map.component';
import { PoiEditComponent } from './popover/poi-edit/poi-edit.component';

@NgModule({
  declarations: [
    BottomDrawerComponent,
    MachineInfoComponent,
    FieldInfoComponent,
    LocationInfoComponent,
    NotificationsComponent,
    ValidationErrorComponent,
    EmployerSelectComponent,
    EmployerSelectDialogComponent,
    EmployerAddDialogComponent,
    MapExaComponent,
    ExaNewMapComponent, 
    MapComponent,
    RequestTestAccountDialogComponent,
    MachineModalComponent,
    FuelAddDialogComponent,
    CommentAddDialogComponent,
    ImplementSelectDialogComponent,
    CustomerSelectDialogComponent,
    BrandSelectDialogComponent,
    SettingsDialogComponent,
    AssignMachineDialogComponent,
    DaySelectorComponent,
    MachineListComponent,
    PoiEditComponent
  ],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule, GoogleMapsModule],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    BottomDrawerComponent,
    MachineInfoComponent,
    FieldInfoComponent,
    LocationInfoComponent,
    NotificationsComponent,
    ValidationErrorComponent,
    EmployerSelectComponent,
    EmployerSelectDialogComponent,
    EmployerAddDialogComponent,
    MapExaComponent,
    RequestTestAccountDialogComponent,
    MachineModalComponent,
    FuelAddDialogComponent,
    CommentAddDialogComponent,
    ImplementSelectDialogComponent,
    CustomerSelectDialogComponent,
    BrandSelectDialogComponent,
    SettingsDialogComponent,
    AssignMachineDialogComponent,
    DaySelectorComponent,
    MachineListComponent,
    ExaNewMapComponent, 
    MapComponent,
    PoiEditComponent
  ],
})
export class SharedComponentsModule {}
